import moment from 'moment'

// สถานะที่ถือว่าคิวนั้นว่างแล้ว ชุดเดียวกับแอปผู้ป่วย (app/screens/Appointment/hooks.js)
// 'DOCTOR_COMPLETD' สะกดผิดในแอป แต่คงไว้ให้ตรงกัน มิฉะนั้นสองฝั่งจะมองคิวว่าง/ไม่ว่างไม่เหมือนกัน
export const RELEASED_BOOKING_STATUS = [
  'DOCTOR_COMPLETD',
  'PHARMACY_COMPLETED',
  'CALL_CENTER_DECLINE',
  'DOCTOR_DECLINE',
  'PHARMACY_DECLINE_BOOKING',
]

// bookingTime เก็บเป็น "นาทีนับจากต้นสัปดาห์" (จันทร์ 00:00) จึงบอกได้ทั้งวันในสัปดาห์และเวลา
// ส่วนวันที่จริงอยู่ใน admitTime
export const minuteOfWeekToLabel = (minuteOfWeek) =>
  moment()
    .startOf('isoWeek')
    .add(minuteOfWeek, 'minutes')
    .format('HH:mm')

export const minuteOfWeekToWeekday = (minuteOfWeek) =>
  moment()
    .startOf('isoWeek')
    .add(minuteOfWeek, 'minutes')
    .day()

// แตกช่วงเวลาว่างรายสัปดาห์ของแพทย์ออกเป็นคิวย่อยตามความยาว slot (availableTime.minute)
export const buildWeeklySlots = (availableTime) => {
  if (!availableTime || !Array.isArray(availableTime.time) || !availableTime.minute) {
    return []
  }
  return availableTime.time.map((range) => {
    const [start, end] = range
    const periods = []
    for (let period = start; period < end; period += availableTime.minute) {
      periods.push(period)
    }
    return {
      weekday: minuteOfWeekToWeekday(start),
      periods,
    }
  })
}

export const slotsForDate = (availableTime, date) => {
  if (!date) {
    return []
  }
  const weekday = moment(date).day()
  return buildWeeklySlots(availableTime)
    .filter((slot) => slot.weekday === weekday)
    .reduce((all, slot) => all.concat(slot.periods), [])
    .sort((a, b) => a - b)
}

export const takenSlotsForDate = (bookings, date) => {
  if (!Array.isArray(bookings) || !date) {
    return []
  }
  const dateKey = moment(date).format('YYYY-MM-DD')
  return bookings
    .filter(
      (booking) =>
        moment(booking.admitTime).format('YYYY-MM-DD') === dateKey &&
        !RELEASED_BOOKING_STATUS.includes(booking.status)
    )
    .map((booking) => booking.bookingTime)
}

// เวลานัดจริงสำหรับใช้ใน payload ของ push notification แบบเดียวกับ
// ActionButtonSection.convertDataBookingTime
export const toNotificationTime = (admitTime, minuteOfWeek) => {
  const label = minuteOfWeekToLabel(minuteOfWeek)
  const [hour, minute] = label.split(':')
  return new Date(admitTime).setHours(Number(hour), Number(minute), 0, 0)
}

// เงื่อนไขวันที่นัดได้ ชุดเดียวกับแอปผู้ป่วย: ล่วงหน้าอย่างน้อย 1 วัน
// ไม่รวมเสาร์-อาทิตย์ ไม่รวมวันหยุดราชการ และวันนั้นต้องมีคิวของผู้ให้บริการจริง
export const isDateSelectable = (availableTime, holidays, date) => {
  if (!date || !availableTime) {
    return false
  }
  const day = moment(date)
  if (!day.isAfter(moment().endOf('day'))) {
    return false
  }
  if ([0, 6].includes(day.day())) {
    return false
  }
  if (holidays.includes(day.format('YYYY-MM-DD'))) {
    return false
  }
  return slotsForDate(availableTime, day).length > 0
}

// วันแรกที่นัดได้ภายใน 60 วันข้างหน้า ใช้เปิดปฏิทินให้ตรงเดือนที่มีคิวจริง
// แทนที่จะทิ้งเจ้าหน้าที่ไว้ที่เดือนปัจจุบันที่อาจกดไม่ได้สักวัน
export const firstSelectableDate = (availableTime, holidays) => {
  const cursor = moment().startOf('day')
  for (let i = 0; i < 60; i += 1) {
    cursor.add(1, 'days')
    if (isDateSelectable(availableTime, holidays, cursor)) {
      return cursor.clone()
    }
  }
  return null
}
